import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        if (!sid) throw new Error("missing session_id");
        const res = await api.post("/auth/session", { session_id: sid });
        setUser(res.data);
        // Verify the cookie session actually persists with a real /auth/me.
        const me = await refresh();
        window.history.replaceState(null, "", window.location.pathname);
        if (!me) { setError(true); return; }
        navigate(me.onboarded ? "/app/discover" : "/onboarding", { replace: true });
      } catch {
        setError(true);
      }
    })();
  }, [navigate, setUser, refresh]);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#0A0908] px-5 text-center" data-testid="auth-error">
        <p className="font-display text-2xl text-[#F4F1EA]">We couldn't sign you in</p>
        <p className="max-w-xs text-sm text-[#8C8578]">Something went wrong while completing Google sign-in.</p>
        <button onClick={() => navigate("/login", { replace: true })} className="rounded-full bg-[#D4AF37] px-6 py-3 text-sm font-semibold text-[#0A0908]" data-testid="auth-error-retry">
          Back to sign in
        </button>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0908]">
      <div className="flex gap-2" data-testid="auth-callback-loading">
        <span className="dot h-2 w-2 rounded-full bg-[#D4AF37]" />
        <span className="dot h-2 w-2 rounded-full bg-[#D4AF37]" />
        <span className="dot h-2 w-2 rounded-full bg-[#D4AF37]" />
      </div>
    </div>
  );
}
